import { Button, Card, CardActionArea, CardActions, CardContent } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";
import { StoreData } from "../../Objects/StoreInterface";
import CustomerBirthday from "../atoms/CustomerBirthday";
import CustomerName from "../atoms/CustomerName";
import MembershipCode from "../atoms/MembershipCode";
import StoreName from "../atoms/StoreName";

export interface StoreCardProps {
    storeData: StoreData
    onClick?: (storeData: StoreData) => void | undefined
    footMenu?: React.ReactNode
}

const StoreCard: React.FC<StoreCardProps> = ({
    storeData,
    onClick,
    footMenu
}) => {
    let { enqueueSnackbar } = useSnackbar()

    let content = (
        <CardContent>
            <StoreName storeData={storeData} />
        </CardContent>
    )

    return (
        <Card variant="outlined">
            {onClick ? (
                <CardActionArea
                    onClick={() => {
                        if (onClick) {
                            onClick(storeData)
                        }
                    }}
                >{content}</CardActionArea>
            ) : (content)}
            {footMenu}
        </Card>
    )
}

export default StoreCard